/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESSubmittedApplications' store object.
 * @namespace ACESSubmittedApplicationsSelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESSubmittedApplications';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESSubmittedApplicationsSelectors
   */
  static fetchAcesSubmittedApplications = state =>
    state[selectors.moduleIdentifier].fetchAcesSubmittedApplications.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESSubmittedApplicationsSelectors
   */
  static isFetchingFetchAcesSubmittedApplications = state =>
    state[selectors.moduleIdentifier].isFetchingFetchAcesSubmittedApplications.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESSubmittedApplicationsSelectors
   */
  static fetchAcesSubmittedApplicationsError = state =>
    state[selectors.moduleIdentifier].fetchAcesSubmittedApplicationsError.payload;
}
